/**
 * 根据最大值和最小值返回一个随机小数
 * @param {Number} min
 * @param {Number} max
 * @returns {Number} 随机小数
 */
export function randomDecimal(min, max) {
  return Math.random() * (max - min) + min
}

// getRandomArbitrary(1.5, 6.5)

/**
 * 根据最大值和最小值返回一个随机整数
 * @param {Number} min
 * @param {Number} max
 * @returns {Number} 随机整数
 */
export function randomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

// getRandomInt(1, 6) // 5

/**
 * 获取指定长度的随机字符串
 * @param {Number} length
 * @returns {Number} 随机字符串
 */
export function randomString(length) {
  var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var result = ''
  for (var i = 0; i < length; ++i) {
    var rand = Math.floor(Math.random() * str.length)
    result += str.substring(rand, rand + 1)
  }
  return result
}
